<template>
  <Flex
    :class="{
      'router-link-exact-active': isCurrentGeoCategory(geoCategory, $route.query, geoType),
    }"
  >
    <Flex :class="{ 'cursor-pointer': true }">
      <router-link class="geo-link" :to="getRoute(geoCategory, geoType)">
        {{ geoCategory.name }}
      </router-link>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'

export default {
  name: 'GeoSelector',
  components: {
    Flex,
  },
  props: {
    geoCategory: Object,
    geoType: String,
  },
  methods: {
    getRoute(geoCategory, geoType) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
        },
      }
      if (geoType === 'geoTypeLatitude') {
        route.query.latitude = geoCategory.attributePath
      }
      if (geoType === 'geoTypeLongitude') {
        route.query.longitude = geoCategory.attributePath
      }
      return route
    },
    isCurrentGeoCategory(geoCategory, query, geoType) {
      if (geoType === 'geoTypeLatitude') {
        return query.latitude === this.geoCategory.attributePath
      }
      if (geoType === 'geoTypeLongitude') {
        return query.longitude === this.geoCategory.attributePath
      }
      return false
    },
  },
}
</script>

<style lang="postcss" scoped>
.geo-link {
  @apply break-words;
}
</style>
